import { i18n } from '@mabinso-registry/module-commons';

interface I18n {
    data: any;
    lang: string;
    _?: any;
}

export default i18n as I18n & typeof i18n;
